import React, { useEffect, useRef, useState } from "react";
import {
  HandsSection,
  ImageCircle,
  SectionCircle,
  BlackDot,
  DescriptionEthic,
  ListItemOther,
  ListItemHonesty,
  ContainerList,
  SectionValues,
  Container,
  Section,
  TextBlock,
  Title,
  LogoImage,
  Doctor,
  Ampoules,
  Hands,
  Subtitle,
  List,
  ListItem,
  RedDot,
  Description,
  Commitment,
  ContainerAbout,
  CircleAnimation,
  SquareImage
} from "./About.style";
import { fadeIn, slideInFromLeft, slideInFromRight, pulse } from "../../styles/Animations";
import DoctorImage from "../../assets/AboutContainer/doctor.png";
import Logo from "../../assets/AboutContainer/logo.png";
import AmpoulesImage from "../../assets/AboutContainer/ampoules.png";
import HandsImageRight from "../../assets/AboutContainer/1.png";
import HandsImageLeft from "../../assets/AboutContainer/2.png";
import CircleImage from "../../assets/AboutContainer/circlepng.png";
import Square from "../../assets/AboutContainer/square.png";

const useIntersectionObserver = (options) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(entry.isIntersecting);
    }, options);

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [options]);

  return [ref, isVisible];
};

const AboutContainer = () => {
  const [headerRef, headerVisible] = useIntersectionObserver({ threshold: 0.1 });
  const [valuesRef, valuesVisible] = useIntersectionObserver({ threshold: 0.1 });
  const [commitmentRef, commitmentVisible] = useIntersectionObserver({ threshold: 0.1 });
  const [handsRef, handsVisible] = useIntersectionObserver({ threshold: 0.1 });
  const [serviceRef, serviceVisible] = useIntersectionObserver({ threshold: 0.1 });
  return (
    <ContainerAbout>
      <Container>
        {/* Header Section */}
        <Section ref={headerRef} style={{ opacity: headerVisible ? 1 : 0, transition: "opacity 1s ease-in-out" }}>
          <Doctor 
            src={DoctorImage} 
            alt="Doctor" 
            style={{ 
              transform: headerVisible ? "translateX(0)" : "translateX(-100%)",
              transition: "transform 1s ease-out"
            }} 
          />
          <TextBlock>
            <Title style={{ 
              opacity: headerVisible ? 1 : 0,
              transition: "opacity 1s ease-out 0.3s"
            }}>
              Calidad y experiencia <br />
              al servicio de la <br />
              medicina integrativa
            </Title>
            <LogoImage 
              src={Logo} 
              alt="Dr. Reckeweg Logo" 
              style={{ 
                opacity: headerVisible ? 1 : 0,
                transition: "opacity 1s ease-out 0.6s"
              }} 
            />
            <CircleAnimation style={{ 
              transform: headerVisible ? "scale(1)" : "scale(0.95)",
              opacity: headerVisible ? 1 : 0,
              transition: "opacity 1s ease-out 0.9s, transform 2s ease-in-out infinite"
            }}>
              <img src={CircleImage} alt="Circle" />
            </CircleAnimation>
          </TextBlock>
        </Section>

        {/* Values Section */}
        <SectionValues ref={valuesRef} style={{ opacity: valuesVisible ? 1 : 0, transition: "opacity 1s ease-in-out" }}>
          <Subtitle style={{ 
            opacity: valuesVisible ? 1 : 0,
            transition: "opacity 1s ease-out"
          }}>¿Qué nos mueve?</Subtitle>
          <ContainerList>
            <List style={{ 
              transform: valuesVisible ? "translateX(0)" : "translateX(-100%)",
              transition: "transform 1s ease-out 0.3s"
            }}>
              <ListItem>
                <RedDot /> Innovación
              </ListItem>
              <Description>
                <BlackDot /> Somos capaces de hacer nuevas y mejores cosas cada
                día, buscando satisfacer las necesidades de los demás y marcando
                un liderazgo en nuestro entorno.
              </Description>
              <ListItemHonesty>
                <RedDot /> Honestidad
              </ListItemHonesty>
              <ListItemOther>
                <RedDot /> Transparencia
              </ListItemOther>
              <ListItemOther>
                <RedDot /> Ética
              </ListItemOther>
              <DescriptionEthic>
                <BlackDot /> Compartimos principios firmes que rigen nuestro
                diario a vivir.
              </DescriptionEthic>
              <DescriptionEthic>
                <BlackDot /> Comprometidos con la verdad y la justicia.
              </DescriptionEthic>
            </List>
            <Ampoules src={AmpoulesImage} alt="Ampoules" />
          </ContainerList>
        </SectionValues>

        {/* Commitment Section */}
        <Commitment ref={commitmentRef} style={{ 
          opacity: commitmentVisible ? 1 : 0, 
          transform: commitmentVisible ? "translateY(0)" : "translateY(50px)",
          transition: "opacity 1s ease-out, transform 1s ease-out"
        }}>
          <p>
            Cultivamos vínculos duraderos con nuestros clientes, inspirados en
            la confianza, el respeto y un compromiso genuino con la integridad.
          </p>
        </Commitment>

        <HandsSection ref={handsRef} style={{
          opacity: handsVisible ? 1 : 0,
          transition: "opacity 1s ease-out"
        }}>
          <Hands 
            src={HandsImageRight} 
            alt="Hands" 
            style={{
              transform: handsVisible ? "translateX(0)" : "translateX(-100%)",
              transition: "transform 1s ease-out"
            }}
          />
          <Hands 
            src={HandsImageLeft} 
            alt="Hands" 
            style={{
              transform: handsVisible ? "translateX(0)" : "translateX(100%)",
              transition: "transform 1s ease-out 0.3s"
            }}
          />
        </HandsSection>

        <SquareImage style={{
          opacity: handsVisible ? 1 : 0,
          transition: "opacity 1s ease-out 0.6s"
        }}>
          <img src={Square} alt="Background" />
        </SquareImage>

        {/* Service Section */}
        <SectionCircle ref={serviceRef} style={{
          opacity: serviceVisible ? 1 : 0,
          transition: "opacity 1s ease-out"
        }}>
          <ImageCircle style={{
            transform: serviceVisible ? "scale(1)" : "scale(0.95)",
            opacity: serviceVisible ? 1 : 0,
            transition: "opacity 1s ease-out, transform 2s ease-in-out infinite"
          }}>
            <img src={CircleImage} alt="Circle" />
          </ImageCircle>
          <List style={{
            transform: serviceVisible ? "translateX(0)" : "translateX(100%)",
            transition: "transform 1s ease-out 0.3s"
          }}>
            <ListItem>
              <RedDot /> Servicio al cliente
            </ListItem>
            <ListItem>
              <RedDot /> Eficacia
            </ListItem>
            <ListItem>
              <RedDot /> Excelencia
            </ListItem>
            <Description>
              <BlackDot />
              Estamos comprometidos a efectuar nuestros labores en el menor
              tiempo posible sin que eso signifique dejar de hacerlas con
              excelencia y nos sentimos recompensados si nuestro mejor esfuerzo
              satisface a los demás.
            </Description>
          </List>
        </SectionCircle>
      </Container>
    </ContainerAbout>
  );
};

export default AboutContainer;
